module.exports = __webpack_public_path__ + "img/zcool.767f546f.png";